import type { VoiceProfile, VoiceProfileUpdate } from '@musedrops/shared';
import { fromDbKeys, toDbKeys } from '@musedrops/shared';
import { supabase } from '../services/supabase';

export async function listVoiceProfiles(): Promise<VoiceProfile[]> {
  const { data, error } = await supabase
    .from('voice_profiles')
    .select('*')
    .order('key');

  if (error) {
    throw new Error(`Failed to fetch voice profiles: ${error.message}`);
  }

  return (data ?? []).map(row =>
    fromDbKeys<VoiceProfile>(row as Record<string, unknown>)
  );
}

export async function updateVoiceProfile(
  id: string,
  updates: VoiceProfileUpdate
): Promise<VoiceProfile> {
  const { data, error } = await supabase
    .from('voice_profiles')
    .update(toDbKeys(updates))
    .eq('id', id)
    .select('*')
    .single();

  if (error) {
    throw new Error(`Failed to update voice profile: ${error.message}`);
  }

  return fromDbKeys<VoiceProfile>(data as Record<string, unknown>);
}

export async function getVoiceProfileByKey(
  key: string
): Promise<VoiceProfile | null> {
  const { data, error } = await supabase
    .from('voice_profiles')
    .select('*')
    .eq('key', key)
    .maybeSingle();

  if (error) {
    throw new Error(`Failed to fetch voice profile: ${error.message}`);
  }

  return data
    ? fromDbKeys<VoiceProfile>(data as Record<string, unknown>)
    : null;
}
